import { createRootRoute, createRoute, createRouter, Outlet } from '@tanstack/react-router';
import AppShellLayout from './components/AppShell';
import { AuthGuard } from './components/AuthGuard';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import PartsPage from './pages/PartsPage';
import QualityPage from './pages/QualityPage';
import ShippingPage from './pages/ShippingPage';
import ClientKeysPage from './pages/ClientKeysPage';
import ImagesPage from './pages/ImagesPage';

const rootRoute = createRootRoute({ component: () => <Outlet /> });

const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  component: Login,
});

const protectedLayout = createRoute({
  getParentRoute: () => rootRoute,
  id: 'protected',
  component: () => (
    <AuthGuard>
      <AppShellLayout />
    </AuthGuard>
  ),
});

const dashboardRoute = createRoute({
  getParentRoute: () => protectedLayout,
  path: '/',
  component: Dashboard,
});
const partsRoute = createRoute({
  getParentRoute: () => protectedLayout,
  path: '/parts',
  component: PartsPage,
});
const qualityRoute = createRoute({
  getParentRoute: () => protectedLayout,
  path: '/quality',
  component: QualityPage,
});
const shippingRoute = createRoute({
  getParentRoute: () => protectedLayout,
  path: '/shipping',
  component: ShippingPage,
});
const clientKeysRoute = createRoute({
  getParentRoute: () => protectedLayout,
  path: '/clients/keys',
  component: ClientKeysPage,
});
const imagesRoute = createRoute({
  getParentRoute: () => protectedLayout,
  path: '/images',
  component: ImagesPage,
});

const routeTree = rootRoute.addChildren([
  loginRoute,
  protectedLayout.addChildren([
    dashboardRoute,
    partsRoute,
    qualityRoute,
    shippingRoute,
    clientKeysRoute,
    imagesRoute,
  ]),
]);

export const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
